<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
  <van-button size="large" type="primary" @click="submit">大号按钮</van-button>
  <van-button size="normal" type="primary">普通按钮</van-button>
  <van-button size="small" type="primary">小型按钮</van-button>
  <van-button size="mini" type="primary">迷你按钮</van-button>
</template>
<script setup>
  import store from '@/store'
  const submit = () => {
    const a = store.dispatch('user/login')
    console.log(a)
  }
</script>
